import React, { useContext, useState } from 'react'
import SearchOptionsContext from 'shared/components/context/search-options'
import Grid from 'shared/components/grid'
import { PublicAPIError } from 'shared/api/errors'
import { SearchOptionsPageData } from 'shared/types/page-data'
import Header from '../containers/header'
import { ExploreHeader } from './header/header'
// import { fetchMixedGrid } from 'shared/api/grid'
import { webFetch } from 'shared/api'

type Props = {
    search: SearchOptionsPageData
    isExplore?: boolean
}

declare global {
    interface Window {
        showExploreClipCarousel: boolean
    }
}

const Search = ({ search, isExplore }: Props) => {
    const { term } = search
    const { type, sort, setSearchResponseId, searchResponseId } = useContext(SearchOptionsContext)
    const [totalCount, setTotalCount] = useState<number>()
    const fetchGifs = async (offset: number) => {
        const result = await webFetch.search(term, {
            offset,
            type,
            sort,
        })

        if (!result?.pagination) {
            throw new PublicAPIError('Error fetching gifs (Component: Search)')
        }
        setTotalCount(result.pagination.total_count)
        if (!searchResponseId) setSearchResponseId(result.meta.response_id)
        return result
    }
    // const fetchMixedGifsAndClips = async (offset: number) => {
    //     const result = await fetchMixedGrid(
    //         term,
    //         {
    //             offset,
    //             type,
    //             sort,
    //         },
    //         4
    //     )

    //     if (!result?.pagination) {
    //         throw new PublicAPIError('Error fetching gifs (Component: Search)')
    //     }
    //     setTotalCount(result.pagination.total_count)
    //     if (!searchResponseId) setSearchResponseId(result.meta.response_id)
    //     return result
    // }

    return (
        <>
            {isExplore ? (
                <ExploreHeader searchInfo={search} isSticker={search.isSticker} />
            ) : (
                <Header searchInfo={search} totalCount={totalCount} />
            )}
            <Grid
                gridTitle={(isExplore && 'All the GIFs') || ''}
                key={`${type} ${sort}`}
                columns={4}
                fetchGifs={fetchGifs}
            />
            {/* {type === 'stickers' ? (
                <Grid
                    gridTitle={(isExplore && 'All the GIFs') || ''}
                    key={`${type} ${sort}`}
                    columns={4}
                    fetchGifs={fetchGifs}
                />
            ) : (
                <Grid
                    gridTitle={(isExplore && 'All the GIFs') || ''}
                    key={`${type} ${sort}`}
                    columns={4}
                    layoutType={isExplore ? 'GRID' : 'MIXED'}
                    fetchGifs={isExplore ? fetchGifs : fetchMixedGifsAndClips}
                />
            )} */}
        </>
    )
}

export default Search
